export const PLATFORMS = [
  { key: "linkedin", label: "LinkedIn", domains: ["linkedin.com"], placeholder: "https://www.linkedin.com/in/your-name" },
  { key: "whatsapp", label: "WhatsApp", domains: ["wa.me", "whatsapp.com"], placeholder: "https://wa.me/15551234567" },
  { key: "instagram", label: "Instagram", domains: ["instagram.com"], placeholder: "https://www.instagram.com/yourhandle" },
  { key: "facebook", label: "Facebook", domains: ["facebook.com", "fb.com"], placeholder: "https://www.facebook.com/yourpage" },
  { key: "x", label: "X", domains: ["x.com", "twitter.com"], placeholder: "https://x.com/yourhandle" },
  { key: "youtube", label: "YouTube", domains: ["youtube.com", "youtu.be"], placeholder: "https://www.youtube.com/@yourchannel" },
  { key: "github", label: "GitHub", domains: ["github.com"], placeholder: "https://github.com/yourname" },
];

const BY_KEY = Object.fromEntries(PLATFORMS.map((p) => [p.key, p]));

// Unknown legacy values still render (generic, scheme-checked only) so existing data never breaks the UI.
export const getPlatform = (key) =>
  BY_KEY[(key || "").toLowerCase()] || { key, label: key || "Link", domains: null, placeholder: "https://" };
